var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 7.04289C7.68342 6.65237 8.31658 6.65237 8.70711 7.04289L16 14.3358L23.2929 7.04289C23.6834 6.65237 24.3166 6.65237 24.7071 7.04289C25.0976 7.43342 25.0976 8.06658 24.7071 8.45711L17.4142 15.75L24.7071 23.0429C25.0976 23.4334 25.0976 24.0666 24.7071 24.4571C24.3166 24.8476 23.6834 24.8476 23.2929 24.4571L16 17.1642L8.70711 24.4571C8.31658 24.8476 7.68342 24.8476 7.29289 24.4571C6.90237 24.0666 6.90237 23.4334 7.29289 23.0429L14.5858 15.75L7.29289 8.45711C6.90237 8.06658 6.90237 7.43342 7.29289 7.04289Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5faa615af7f539bd1053f4d3b61f0392.svg";
export { ForwardRef as ReactComponent };